import type { SyncStatus } from './ports/SyncPorts.ts';

const CATALOG_STALE_MS = 7 * 24 * 60 * 60 * 1000;

export function syncCatalogNeedsDownload(status: SyncStatus): boolean {
  if (!status.remoteAvailable) return false;
  if (status.lastError) return true;
  if (!status.lastPullAt) return true;
  const pulled = Date.parse(status.lastPullAt);
  if (!Number.isFinite(pulled)) return true;
  return Date.now() - pulled > CATALOG_STALE_MS;
}

export function syncCatalogAlertMessage(status: SyncStatus): string | null {
  if (!syncCatalogNeedsDownload(status)) return null;
  if (status.lastError) {
    return 'No se pudieron descargar los catálogos. Con red, abra Sincronización y pulse Descargar catálogos.';
  }
  if (!status.lastPullAt) {
    return 'Los catálogos del servidor no se han descargado en este dispositivo. Con red, pulse Descargar catálogos en Sincronización.';
  }
  return 'Los catálogos pueden estar desactualizados. Con red, pulse Descargar catálogos en Sincronización.';
}

export function syncCatalogAlertTone(status: SyncStatus): 'warning' | 'error' {
  return status.lastError ? 'error' : 'warning';
}
